//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import travelsApi from '@/api/travels'
import EsQuery from "@/javascript/esQuery"

export default {
    data() {
        return {
            loading: false, // 加载状态
            finished: true, // 加载结束
            refreshing: false, // 下拉状态
            result: [],
            activeIndex: 0,
            sitesType: [
                {
                    name: '住宿'
                },
                {
                    name: '美食'
                },
                {
                    name: '景点'
                }
            ],
            pageParams: {
                pageNum: 0,
                pageSize: 10
            },
            rightDataLists: [],
            hotel: [],
            periphery: [],
            scenic: [],
            onChangeList: []
        };
    },
    computed: {
        routeType() {
            return this.$route.query.type;
        }
    },
    mounted() {
        const _this = this
        console.log(_this.$tools.getStorage('resultList'), 'this.$route.query.key')

        if (this.$tools.getStorage('resultList')) {

            // this.result = JSON.parse(this.$tools.getStorage('resultList'))
            const xx = JSON.parse(this.$tools.getStorage('resultList'));
            xx.map(item => {
                return item._id;
            });
            this.result = xx;
        }
        if (this.$tools.getStorage('wholeList')) {
            const wholeList = JSON.parse(this.$tools.getStorage('wholeList'));
            this.result = wholeList;
        }
        if (this.$route.query.key == '1') {
            this.activeIndex = 0;
            this.getList();
        } else if (this.$route.query.key == '2') {
            this.activeIndex = 1;
            this.getList();
        } else {
            this.activeIndex = 2;
            this.getList();
        }
    },
    methods: {
        getSearchLists(params) {
            return new Promise((resolve, reject) => {
                this.$http.
                    post('/api/wtcp-kb/pub/doc/search', params)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },


        // 选择关联场所
        handleSelectSites(item) {
            // this.$router.replace({
            //   name: 'writeDetail',
            //   query: {
            //     type: this.routeType
            //   }
            // });
        },
        changeTab(index) {
            this.activeIndex = index;
            this.rightDataLists = [];
            this.getList();
        },
        async getList() {
            const self = this;
            const routerName = self.$route.name;
            //参数
            const query = new EsQuery();
            const querystring = require('querystring');
            if (this.activeIndex == 0) {
                let indexName = self.INDEX_NAME_TYPE.hotelList;
                query
                    // .addStartWith('deptCode', '1000100001', query.and, false)
                    .addSort('weight', query.desc, false)
                    .addPage(self.pageParams.pageNum * self.pageParams.pageSize, self.pageParams.pageSize);
                // if (routerName === 'hotel') {
                //     // 酒店
                //     query.addStartWith('category', self.XXCJ_TYPE_CODE.JDMS, query.not, false);
                // } else {
                //     // 客栈
                //     query.addStartWith('category', self.XXCJ_TYPE_CODE.JDMS, query.and, false);
                // }
                let esJsonQuery = JSON.stringify(query.getArray());
                let params = querystring.stringify({ indexName, esJsonQuery });
                let res = await self.getSearchLists(params);
                let data = res.data;
                if (data) {
                    this.rightDataLists = data;
                    this.hotel = data;
                    this.$tools.setStorage('hotel', this.hotel);
                    this.loading = false;
                    // 当还有数据是page++
                    // if (res.data.records.length > 0) {
                    //   // this.pageParams.pageNum++;
                    //   this.loading = false;
                    // } else {
                    //   // 如果没有数据加载完毕
                    //   this.finished = true;
                    // }
                }
            } else if (this.activeIndex == 1) {
                let indexName = self.INDEX_NAME_TYPE.periphery;
                query
                    // .addStartWith('deptCode', self.DEPT_CODE.DEPTCODE, query.and, false)
                    .addString('category', self.XXCJ_TYPE_CODE.CY, query.and, false)
                    .addSort('weight', query.desc, false)
                    // .addStartWith('region', self.DEPT_CODE.REGION, query.and, false)
                    .addPage(self.pageParams.pageNum * self.pageParams.pageSize, self.pageParams.pageSize);

                let esJsonQuery = JSON.stringify(query.getArray());
                let params = querystring.stringify({ indexName, esJsonQuery });
                // 请求
                let result = await self.getSearchLists(params);
                if (result.data) {
                    const data = result.data;
                    this.periphery = data;
                    this.$tools.setStorage('periphery', this.periphery);
                    self.rightDataLists = self.rightDataLists.concat(
                        data.map(item => {
                            let local = self.location ? self.location.position : '';
                            let distance = local
                                ? self.$mapUtil.getDistance(local.lng, local.lat, item._source.longitude, item._source.latitude)
                                : '';
                            return {
                                ...item,
                                distance,
                                // 封面图片
                                coverImg: item._source.images && item._source.images[0] ? item._source.images[0] : ''
                            };
                        })
                    );
                }
            } else if (this.activeIndex == 2) {
                let indexName = self.INDEX_NAME_TYPE.scenic;
                query;
                query
                    .addString('category', self.XXCJ_TYPE_CODE.JQ, query.and, false)
                    // .addStartWith('deptCode', self.DEPT_CODE.DEPTCODE, query.and, false)
                    // .addSort('level', query.desc, false)
                    .addSort('weight', query.desc, false)
                    // .addString('publishStatus', 1, query.and, false)
                    .addPage(self.pageParams.pageNum * self.pageParams.pageSize, self.pageParams.pageSize);

                let esJsonQuery = JSON.stringify(query.getArray());
                let params = querystring.stringify({ indexName, esJsonQuery });
                // 请求
                let result = await self.getSearchLists(params);
                if (result.data) {
                    const data = result.data;
                    this.scenic = data;
                    this.$tools.setStorage('scenic', this.scenic);
                    self.rightDataLists = self.rightDataLists.concat(
                        data.map(item => {
                            let local = self.location ? self.location.position : '';
                            let distance = local
                                ? self.$mapUtil.getDistance(local.lng, local.lat, item._source.longitude, item._source.latitude)
                                : '';
                            return {
                                ...item,
                                distance,
                                // 封面图片
                                // coverImg: item._source.images && item._source.images[0] ? item._source.images[0] : ''
                                coverImg: item._source.images[0][0].fileUrl
                            };
                        })
                    );
                }
            }
        },
        // 上拉加载
        onLoad() {
            this.getList();
        },
        // 下拉刷新
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.reset();
            this.getList();
            this.refreshing = false;
        },
        // 重置
        reset() {
            // this.rightDataLists = []
            // this.pageParams.pageNum = 1
        },
        onChange(e) {
            this.result = e;
            this.$tools.setStorage('resultList', this.result);
            this.onChangeList = e;
        },
        handleSave() {
            this.onChangeList = [];
        },
        handleSubmit() {
            // this.onChangeList.splice(0,2)
            this.$tools.setStorage('onChangeList', this.onChangeList);

            this.$tools.removeStorage('wholeList');

            const value = this.onChangeList.map(item => {
                return item;
            });
            if (this.$route.query.id) {
                this.$router.push({
                    name: 'travelsNotes',
                    query: {
                        id: this.$route.query.id
                    }
                });
            } else {
                this.$router.push({
                    name: 'travelsNotes',
                    params: {
                        key: value
                    }
                });
            }
        },
        clickThemaLayer(checkbox) {
            // var index = this.onChangeList.findIndex((item)=>{
            //   return item == checkbox.value
            // })
            // if(index == -1){
            //   console.log('选中')
            // }else{
            //   console.log('取消')
            // }
        }
    }
};
